/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import Component from "@glimmer/component";
import type DmpConnectJSAuthenticationContextAdapter from "parog-web/contexts/dmpconnect-js/authentication-context-adapter";

interface Args {
  context: DmpConnectJSAuthenticationContextAdapter;
}
export default class CnamServicesAccessFormAuthenticationSetPinCodeAndComputerSettingsComponent extends Component<Args> {
  constructor(owner: unknown, args: Args) {
    super(owner, args);

    this.args.context.computerLocation =
      this.args.context.dmpConnect.selectedHealthCentreForMedic(
        this.args.context.medic
      ) || undefined;
  }

  get canSubmit(): boolean {
    return (
      this.args.context.pinCodeManager.isTypedPinCodeValid &&
      Boolean(this.args.context.computerLocation)
    );
  }

  @action
  setSelectedHealthCentre(value: string): void {
    this.args.context.computerLocation = value;
  }

  @action
  onPinCodeChanged(e) {
    this.args.context.pinCodeManager.typedPinCode = e.target.value;
  }

  @action
  onSubmit(event: SubmitEvent): void {
    event.preventDefault();
    this.args.context.transitionTo();
  }
}
